import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dac5988c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex-1 text-13 pr-10" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "add-to-basket-area" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_6 = { class: "flex justify-end items-center px-15 py-7" }
const _hoisted_7 = { class: "ml-3" }
const _hoisted_8 = ["reserve-space-for-add-to-basket"]
const _hoisted_9 = ["disabled", "onClick"]

import { computed, ComputedRef, Ref, ref } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { ProductSpotModel, PurchaseOptionType } from '@/types/productServerApi';
import { DeliverableType, BaseProductItem } from '@/b2c/shared/api/server-apis';
import { useAddToBasket } from '@/b2c/product/purchase/useAddToBasket';
import useBasket from '@/b2c/basket/useBasket';
import useProductPurchase from '@/shared/product/purchase/ui/useProductPurchase';
import { useUpSellItems } from '@/b2c/basket/useUpSellItems';
import basketTrackingService from '@/shared/tracking/basket-tracking.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemUpSell',
  props: {
    itemId: null,
    deliverableType: null
  },
  setup(__props: any) {

const props = __props as {
    itemId: number;
    deliverableType: DeliverableType,
}



const labels = useBlockLabels();
const { getUpsellItems, getUpsellItemsFoundInBasket } = useUpSellItems();
const { addToBasket } = useAddToBasket();
const { deliverables, clickAndCollectStoreId, hasClickAndCollectDeliverable, basket } = useBasket();
const { getPreferredPurchaseOptionType } = useProductPurchase();

const products: ComputedRef<ProductSpotModel[] | undefined> = computed(() => {
    const upsellItems = getUpsellItems(props.itemId);

    return upsellItems
        ? upsellItems.splice(0, 1)
        : upsellItems;
});

const pending: Ref<boolean> = ref(false);

const alreadyInBasket = (upsellItem) => {
    let foundInBasket = false;
    const upsellInBasket = getUpsellItemsFoundInBasket(props.itemId, upsellItem.sku);

    deliverables.value.forEach((deliverable) => {
        if (deliverable.items.find((product) => (product as BaseProductItem).sku === upsellItem.sku && upsellInBasket)) {
            foundInBasket = true;
        }
    });
    return foundInBasket;
};

const parentProductPurchaseOption = computed(() => {
    switch (props.deliverableType) {
    case DeliverableType.ClickAndCollect:
        return PurchaseOptionType.ClickAndCollect;
    case DeliverableType.PickAndPack:
        return PurchaseOptionType.PickAndPack;
    default: return PurchaseOptionType.Standard;
    }
});

const addUpsellItem = async(product: ProductSpotModel, index: number): Promise<void> => {
    const preferredPurchaseOption = getPreferredPurchaseOptionType(product.purchaseOptions, parentProductPurchaseOption.value, clickAndCollectStoreId.value ?? null, hasClickAndCollectDeliverable.value);
    if (preferredPurchaseOption !== null) {
        try {
            pending.value = true;
            await addToBasket(product.sku, preferredPurchaseOption, product.quantityMultiplier, props.itemId);
            basketTrackingService.basketRecommendedProducts(basket.value, product, preferredPurchaseOption, index);
        } finally {
            pending.value = false;
        }
    }
};


return (_ctx: any,_cache: any) => {
  const _component_ProductImage = _resolveComponent("ProductImage")!
  const _component_PDPLink = _resolveComponent("PDPLink")!
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(_Transition, { name: "o-anim-fade-300" }, {
    default: _withCtx(() => [
      (!!_unref(products)?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products), (product, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: product.sku,
                class: "bg-wild-sand px-x2 py-14 mt-x3 flex flex-wrap gap-y-x3 justify-between w-full items-center"
              }, [
                _createVNode(_component_PDPLink, {
                  sku: product.sku,
                  title: product.name,
                  class: "w-90 pr-15"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ProductImage, {
                      sku: product.sku,
                      alt: product.name,
                      "aspect-ratio": 4/3,
                      "width-on-screen": 1,
                      class: "w-full"
                    }, null, 8, ["sku", "alt"])
                  ]),
                  _: 2
                }, 1032, ["sku", "title"]),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_PDPLink, {
                    sku: product.sku,
                    class: "text-13 font-bold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(product.description ? product.name : _unref(labels).lineItemUpSellItemRecommendTitle), 1)
                    ]),
                    _: 2
                  }, 1032, ["sku"]),
                  _createElementVNode("div", {
                    title: product.name,
                    class: "block"
                  }, _toDisplayString(product.description || product.name), 9, _hoisted_3),
                  _createElementVNode("div", null, _toDisplayString(product.price.salesPrice.amount), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_Transition, {
                    name: "o-anim-fade-300",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (alreadyInBasket(product))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                            _createElementVNode("span", _hoisted_6, [
                              _createVNode(_component_c_icon, {
                                name: "icon-checkmark",
                                class: "h-12"
                              }),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(labels).lineItemUpSellItemAddedToBasketButton), 1)
                            ]),
                            _createElementVNode("span", {
                              class: "reserve-space-for-add-to-basket",
                              "reserve-space-for-add-to-basket": _unref(labels).lineItemUpSellItemAddToBasketButton
                            }, null, 8, _hoisted_8)
                          ]))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "c-button c-button--basket w-auto",
                            disabled: pending.value,
                            onClick: _withModifiers(($event: any) => (addUpsellItem(product, index)), ["prevent"])
                          }, _toDisplayString(_unref(labels).lineItemUpSellItemAddToBasketButton), 9, _hoisted_9))
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})